import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'legal-incapacity-limits',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'legal-incapacity-limits-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.legal-incapacity-limits-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "legal-incapacity-limits-index" */ '@/modules/configurations/catalogs/legal-incapacity-limits/views/Index.vue')
        },
        {
            path: 'create',
            name: 'legal-incapacity-limits-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'legal-incapacity-limits-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.legal-incapacity-limits-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.legal-incapacity-limits-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "legal-incapacity-limits-create" */ '@/modules/configurations/catalogs/legal-incapacity-limits/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'legal-incapacity-limits-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'legal-incapacity-limits-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.legal-incapacity-limits-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.legal-incapacity-limits-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "legal-incapacity-limits-edit" */ '@/modules/configurations/catalogs/legal-incapacity-limits/views/Edit.vue')
        }
    ]
}